@if (mediaTpl) {
  <div class="card-figure-wrapper">
    <ng-content select="[media]"></ng-content>
  </div>
}

<div class="card-content-wrapper">
  <div class="card-header">
    <ng-content select="[icon]"></ng-content>
    <ng-content select="[meta-items='header']"></ng-content>
  </div>

  <div class="card-content">
    <ng-content select="[topline]"></ng-content>
    <ng-content select="[headline]"></ng-content>
    <ng-content select="[text]"></ng-content>
    <ng-content select="[fuel-label]"></ng-content>
  </div>

  @if (!sperateFooter) {
    <ng-container [ngTemplateOutlet]="footerTpl"></ng-container>
  }
</div>
@if (sperateFooter) {
  <ng-container [ngTemplateOutlet]="footerTpl" [ngTemplateOutletContext]="{ seperated: true }"></ng-container>
}

<ng-template #footerTpl let-seperated="seperated">
  <div class="card-footer" [class.seperated-footer]="seperated">
    <ng-content select="[meta-items]"></ng-content>
    <ng-content select="[tags]"></ng-content>
    <ng-content select="[action-container]"></ng-content>
  </div>
</ng-template>
